/* @flow */
import type { Action } from "../action";
import type { OperationClosed } from "../CommonTypes";

export type News = {
  payload: OperationClosed,
  isDismissed: boolean
};

export type State = Array<News>;

function receiveSocketMessage(state, payload) {
  switch (payload.op) {
    case "operationClosed":
      return [...state, { payload, isDismissed: false }];
    case "tournamentOperationClosed":
      return [...state, { payload, isDismissed: false, isTournament: true }];
    default:
      return state;
  }
}

function dismiss(state, id) {
  return state.map(
    news => (news.payload.id === id ? { ...news, isDismissed: true } : news)
  );
}

function news(state: State = [], action: Action): State {
  switch (action.type) {
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    case "DISMISS_NEWS":
      return dismiss(state, action.payload);
    default:
      return state;
  }
}

export default news;



// WEBPACK FOOTER //
// ./src/redux/reducer/news.js